// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar_icon svg {
    color: #2a2525;
    stroke: #2a2525;
    transition: color 0.3s ease, stroke 0.3s ease;
}

.sidebar_icon:hover svg {
    color: #2a2525;
    stroke: #2a2525;
}

.sidebar_icon.active svg {
    color: #2a2525;
    font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/styles/subsidebar/styles.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,eAAe;IACf,6CAA6C;AACjD;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB","sourcesContent":[".sidebar_icon svg {\n    color: #2a2525;\n    stroke: #2a2525;\n    transition: color 0.3s ease, stroke 0.3s ease;\n}\n\n.sidebar_icon:hover svg {\n    color: #2a2525;\n    stroke: #2a2525;\n}\n\n.sidebar_icon.active svg {\n    color: #2a2525;\n    font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
